import { IRoute } from '@interfaces/routes';
import urls from '@routes/urls';
import AdminInquiriesPage from '@views/AdminInquiriesPage/AdminInquiriesPage';
import AdminPage from '@views/AdminPage/AdminPage';
import HomePage from '@views/HomePage/HomePage';
import InfoPage from '@views/InfoPage/InfoPage';
import InquiriesPage from '@views/InquiriesPage/InquiriesPage';
import InquiryDraftPage from '@views/InquiryDraftPage/InquiryDraftPage';
import InquiryResponsePage from '@views/InquiryResponsePage/InquiryResponsePage';
import PrintInquiryResponsePage from '@views/InquiryResponsePage/PrintInquiryResponsePage/PrintInquiryResponsePage';
import MedicationsPage from '@views/MedicationsPage/MedicationsPage';
import UnderConstructionPage from '@views/UnderConstructionPage/UnderConstructionPage';

const privateRoutes: IRoute[] = [
  {
    path: urls.home,
    component: HomePage,
  },
  {
    path: urls.inquiryDraft,
    component: InquiryDraftPage,
  },
  {
    path: urls.inquiryDetails,
    component: InquiryDraftPage,
  },
  {
    path: urls.inquiryResponse,
    component: InquiryResponsePage,
  },
  {
    path: urls.printInquiryResponse,
    component: PrintInquiryResponsePage,
  },
  {
    path: urls.medications,
    component: MedicationsPage,
  },
  {
    path: urls.faq,
    component: UnderConstructionPage,
  },
  {
    path: urls.disclaimer,
    component: UnderConstructionPage,
  },
  {
    path: urls.inquiries,
    component: InquiriesPage,
  },
  {
    path: urls.profile,
    component: UnderConstructionPage,
  },
  {
    path: urls.adminHome,
    component: AdminPage,
    admin: true,
  },
  {
    path: urls.adminInquiries,
    component: AdminInquiriesPage,
    admin: true,
  },
  {
    path: urls.infoPage,
    component: InfoPage,
  },
];

export default privateRoutes;
